<script setup lang="ts">
import { computed } from 'vue'
import { useMicLevelMeter } from '~/lib/livekit/micLevelMeter'
import { liveKitManager } from '~/lib/livekit/manager'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import LevelMeterBars from '~/components/voice-ui/LevelMeterBars.vue'

const props = defineProps<{
  /** Capture the selected mic outside a call too (the settings page), see `previewDeviceId`. */
  preview?: boolean
  /** Mark this speaking threshold on the meter. */
  threshold?: number
}>()

const { level } = useMicLevelMeter(
  props.preview ? { previewDeviceId: () => liveKitManager.state.selectedMicId } : undefined,
)
const levelPercent = computed(() => Math.round(level.value * 100))
</script>

<template>
  <Tooltip>
    <TooltipTrigger as-child>
      <div aria-label="Уровень сигнала микрофона">
        <LevelMeterBars :level="level" :threshold="threshold" />
      </div>
    </TooltipTrigger>
    <TooltipContent side="top">{{ levelPercent }}%</TooltipContent>
  </Tooltip>
</template>
